<template>
  <div class="app-analysis-roles-avatars">
    <app-user-role-avatar
      role="f2c"
      :user="f2cUser"
      :users="volateqUsers"
      :editable="editable"
      :loading="loading"
      :inline="inline"
      @select="onSelect('f2c', $event)"
    />
    <app-user-role-avatar
      role="ops"
      :user="opsUser"
      :users="volateqUsers"
      :editable="editable"
      :loading="loading"
      :inline="inline"
      @select="onSelect('ops', $event)"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import { BaseComponent } from "../base-component/base-component";
import { CatchError } from "@/app/shared/services/helper/catch-helper";
import { AvatarUserSchema, SimpleUserRoleSchema } from "@/app/shared/services/volateq-api/api-schemas/user-schemas";
import AppUserRoleAvatar, { UserRole } from "./user-role-avatar.vue";

export interface AnalysisRolesChange {
  role: UserRole;
  userId: string | null;
}

@Component({
  name: "app-analysis-roles-avatars",
  components: {
    AppUserRoleAvatar,
  },
})
export default class AppAnalysisRolesAvatars extends BaseComponent {
  @Prop({ default: null }) f2cUser!: AvatarUserSchema | null;
  @Prop({ default: null }) opsUser!: AvatarUserSchema | null;
  @Prop({ default: () => [] }) volateqUsers!: SimpleUserRoleSchema[];
  @Prop({ default: false }) editable!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: false }) inline!: boolean;

  @CatchError()
  onSelect(role: UserRole, userId: string | null) {
    this.$emit("change", { role, userId } as AnalysisRolesChange);
  }
}
</script>

<style lang="scss">
.app-analysis-roles-avatars {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
</style>
